module.exports = __webpack_public_path__ + "dc4041813e87482318b8b9c5db88388e.jpg";